import {
   ConfidentialityConfiguration,
   ConfidentialityConfigurationQuery,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type ConfidentialitySettingsRenderProps = {
   confidentialityConfiguration: ConfidentialityConfiguration;
};

type ConfidentialitySettingsLoaderProps = {
   readonly children: (renderProps: ConfidentialitySettingsRenderProps) => JSX.Element;
};

export const ConfidentialitySettingsLoader = (props: ConfidentialitySettingsLoaderProps): JSX.Element => {
   const {
      data: confidentialityConfiguration,
      loading: confidentialityConfigurationLoading,
      error: confidentialityConfigurationError,
   } = useCqrsGet<ConfidentialityConfiguration>(() => new ConfidentialityConfigurationQuery());

   if (confidentialityConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (confidentialityConfigurationError) {
      return (
         <Message
            testId={'confidentialityConfigurationFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      confidentialityConfiguration: confidentialityConfiguration,
   });
};
